import { formatNumber } from '../../../../utils/helpers';

export function getMinSqFt(totalSqFt) {
    if (!totalSqFt) return null;

    // Determine min from total sq ft
    if (totalSqFt <= 49999) return 0;
    else if (totalSqFt <= 99999) return 50000;
    else if (totalSqFt <= 249999) return 100000;
    else if (totalSqFt <= 499999) return 250000;
    else if (totalSqFt <= 999999) return 500000;
    else return 1000000; // >= 100000
}

export function calculateSpaceMaxSqFt(property) {
    
    return property.spaces.reduce((spacesTotal, space) => {
        let max = 0;
        const { space_available, minimum_divisible, maximum_contiguous } = space.space;
        const available = parseInt(space_available, 10);
        const minDivisible = parseInt(minimum_divisible, 10);
        const maxContiguous = parseInt(maximum_contiguous, 10);

        if ((available >= minDivisible) && (available >= maxContiguous)) {
            max = available;
        } else if ((minDivisible >= available) && (minDivisible >= maxContiguous)) {
            max = minDivisible;
        } else {
            max = maxContiguous;
        }

        return (max >= spacesTotal) ? max : spacesTotal;
    }, 0);
}

export function calculateMaxAvailableSqFt(properties) {
    if (!properties || properties.length === 0) return null;

    // NOTE: Before was just returning the reduce instead of capping it at 100,000
    const maxAvailSqFt =  properties.reduce((propertyTotal, property) => {
        const propertyAvailSqFt = property.space_available;
        
        if (!property.spaces) {
            return propertyAvailSqFt;
        }

        const maxFromSpaces = calculateSpaceMaxSqFt(property);

        if (propertyTotal >= propertyAvailSqFt && propertyTotal >= maxFromSpaces) {
            return propertyTotal;
        }
        
        return (propertyAvailSqFt > maxFromSpaces) ? propertyAvailSqFt : maxFromSpaces;
    }, 0);

    // Here we validate that the value is not greater, if it's the case we cap at 100,000
    return (maxAvailSqFt >= 100000) ? 100000 : maxAvailSqFt;
}

export function calculateTotalSpace(properties) {
    if (!properties || properties.length === 0) return null;

    // "rba" is the total sq ft
    return properties.reduce((total, property) => total + property.rba, 0);
}

export function getTotalText(properties) {
    if (!properties || properties.length === 0) return null;

    const visibleProperties = properties.filter(property => property.showMarker);
    const totalSpace = formatNumber(calculateTotalSpace(visibleProperties));
    
    return `${visibleProperties.length} ${visibleProperties.length === 1 ? 'PROPERTY' : 'PROPERTIES'} / ${totalSpace} SQ. FT.`;
}
